module.exports = __webpack_public_path__ + "static/media/content-generation.e96342aa.svg";